import React from "react";
import CloserLogoSvg from "../../../assets/closer_logo.svg";
import styles from "./closerLogo.css";

interface Props {
  className?: string;
}

export const CloserLogo = ({ className }: Props) => {
  return (
    <div className={styles.container}>
      <img src={CloserLogoSvg} className={className} />
    </div>
  );
};
